import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { QUERY_KEY } from '@/modules/user/queries/useEmployeeViewData.query';

import { EmployeePayload } from '../user.types';

interface UpdateEmployeePayload {
  is_electronic_statement_only: boolean;
  employee_provided_email: string | null;
  is_employee_email_preferred: boolean;
  citizenship_country_id: number;
  is_sms_notification_enabled: boolean;
  mailing_address: EmployeePayload['mailing_address'];
}

const useUpdateEmployeeQuery = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (data: Partial<UpdateEmployeePayload>) =>
      api.patch(API_URL.UI_EMPLOYEES, {
        ...data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  return {
    updateEmployee: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useUpdateEmployeeQuery;
